<div class="legal-page">
  <a class="legal-page__back" href="/registration">
    <mat-icon style="font-size:1rem;width:1rem;height:1rem">arrow_back</mat-icon>
    Zurück zur Registrierung
  </a>

  <h1 class="legal-page__title">Datenschutzerklärung</h1>
  <p class="legal-page__date">Stand: April 2026</p>

  <div class="legal-page__body">
    <h2>1. Verantwortlicher</h2>
    <p>
      Verantwortlicher im Sinne der DSGVO ist die Insirion GmbH.
      Bei datenschutzrelevanten Anfragen wenden Sie sich bitte an:
      datenschutz&#64;docuty.de
    </p>

    <h2>2. Erhobene Daten</h2>
    <p>
      Im Rahmen der Registrierung erheben wir: Name, E-Mail-Adresse,
      Firmenname sowie Zahlungsinformationen (verarbeitet durch Stripe).
      Im laufenden Betrieb werden Nutzungsdaten und hochgeladene
      Dokumentationsdaten gespeichert.
    </p>

    <h2>3. Zweck der Verarbeitung</h2>
    <p>
      Die erhobenen Daten werden ausschließlich zur Bereitstellung und
      Verbesserung der Docuty-Plattform sowie zur Vertragserfüllung verwendet.
    </p>

    <h2>4. Rechtsgrundlage</h2>
    <p>
      Die Verarbeitung erfolgt auf Basis von Art. 6 Abs. 1 lit. b DSGVO
      (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
    </p>

    <h2>5. Datenweitergabe</h2>
    <p>
      Daten werden nicht an Dritte verkauft. Zahlungsabwicklung erfolgt
      über Stripe Payments Europe Ltd. Weitere Auftragsverarbeiter sind in
      unserem Verarbeitungsverzeichnis dokumentiert.
    </p>

    <h2>6. Speicherdauer</h2>
    <p>
      Daten werden gelöscht, sobald sie für die Verarbeitung nicht mehr
      erforderlich sind und keine gesetzlichen Aufbewahrungspflichten bestehen.
    </p>

    <h2>7. Ihre Rechte</h2>
    <p>
      Sie haben das Recht auf Auskunft, Berichtigung, Löschung,
      Einschränkung der Verarbeitung sowie Datenübertragbarkeit.
      Wenden Sie sich hierfür an datenschutz&#64;docuty.de.
    </p>

    <h2>8. Beschwerderecht</h2>
    <p>
      Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde
      zu beschweren. Zuständig ist die Behörde am Unternehmenssitz.
    </p>
  </div>
</div>
